module.exports = __webpack_public_path__ + "assets/img/xlwy_2.d554d8f5.png";